import CustomerOrderHistory from '@screens/customer/order/history'

export default function CustomerOrderHistoryPage() {
  return <CustomerOrderHistory />
}
